<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="locationId" id="locationId" type="number" pInputText>
            <label for="locationId">Location ID</label>
            @for (validation of validationMessages.locationId; track validation) {
              <span>
                @if (form1.get('locationId').hasError(validation.type) && (form1.get('locationId').dirty || form1.get('locationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="locationTypeId" id="locationTypeId" type="number" pInputText>
            <label for="locationTypeId">Location Type ID</label>
            @for (validation of validationMessages.locationTypeId; track validation) {
              <span>
                @if (form1.get('locationTypeId').hasError(validation.type) && (form1.get('locationTypeId').dirty || form1.get('locationTypeId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="parentLocationId" id="parentLocationId" type="number" pInputText>
            <label for="parentLocationId">Parent Location ID</label>
            @for (validation of validationMessages.parentLocationId; track validation) {
              <span>
                @if (form1.get('parentLocationId').hasError(validation.type) && (form1.get('parentLocationId').dirty || form1.get('parentLocationId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="timeZone" id="timeZone" type="text" pInputText>
            <label for="timeZone">Time Zone</label>
            @for (validation of validationMessages.timeZone; track validation) {
              <span>
                @if (form1.get('timeZone').hasError(validation.type) && (form1.get('timeZone').dirty || form1.get('timeZone').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (rUDetailedLocationId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete RU Detailed Location</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!rUDetailedLocationId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add RU Detailed Location</button>
              }

              @if (rUDetailedLocationId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update RU Detailed Location</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>